import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { BrandButton } from "@/components/common/BrandButton";
import { SectionHeader } from "@/components/common/SectionHeader";
import { LandingDemoExperience } from "@/components/landing/LandingDemoExperience";
import { LANDING_SHOWCASE } from "@/config/landingContent";
import { LANDING_DEMO } from "@/config/landingDemo";

const secondaryBtnClass =
  "border border-zinc-700 text-white rounded-full px-6 py-3 hover:bg-zinc-900 bg-transparent h-auto text-sm";

export function LandingShowcase() {
  return (
    <section id="demo" className="scroll-mt-10 py-16 md:py-24 bg-zinc-900/50">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="text-center mb-12">
          <SectionHeader
            title={LANDING_SHOWCASE.title}
            subtitle={LANDING_SHOWCASE.subtitle}
            dataTestId="landing-showcase-title"
          />
        </div>

        <LandingDemoExperience
          // className="mb-8"
          fallbackMessage={LANDING_SHOWCASE.fallbackMessage}
        />

        {/* <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <BrandButton asChild>
            <Link
              to={LANDING_DEMO.projectPath}
              data-testid="landing-demo-open-project-btn"
            >
              {LANDING_SHOWCASE.openProjectLabel}
            </Link>
          </BrandButton>
          <Button variant="outline" className={secondaryBtnClass} asChild>
            <Link
              to={LANDING_DEMO.portfolioPath}
              data-testid="landing-demo-portfolio-btn"
            >
              {LANDING_SHOWCASE.portfolioLabel}
            </Link>
          </Button>
        </div> */}
      </div>
    </section>
  );
}
